export default __webpack_public_path__ + "static/timespread-f28e2457616dadffb494ddea42e7aac2.jpg";